<template>
  <div>
    <div class="homeImg " dark :src="require('../../public/img/Bandeau2.png')">
      <!-- <div v-if=" getLang()==='fr' ">
      <div v-if=" getRoute()==='kkbb'" >
      <a :href="urlkkbb()" target="_blank"><v-img :src="requireImgkkbb()" class="bandeauKkbb hidden-md-and-down" /></a>
      <a :href="urlkkbb()" target="_blank"><v-img :src="requireImgkkbb()" class="bandeauKkbbMobile hidden-lg-and-up" /></a>
    </div>
    <div v-else>
      <a :href="urlkkbb()"><v-img :src="requireImgkkbb()" class="bandeauKkbbMobile hidden-lg-and-up" /></a>
      <a :href="urlkkbb()"><v-img :src="requireImgkkbb()" class="bandeauKkbb hidden-md-and-down" /></a>
    </div>
    </div> -->

      <v-layout align-left row>
        <v-avatar tile size="560px">
          <div class="headerMobile">
            <a @click="$router.push('/')">
              <v-img
                :src="require('../../public/img/Logos shayofae 512x512.png')"
                contain
                aspect-ratio="1"
                width="300"
                height="240"
                position="center"
                class="hidden-md-and-up"
              />
            </a>
            <v-img
              :src="requireImg()"
              contain
              aspect-ratio="1"
              :width="width"
              height="280"
              position="top"
              class="hidden-sm-and-up"
            />
          </div>
          <v-container class="hidden-md-and-down">
            <v-layout column>
              <a @click="$router.push('/')">
                <v-img
                  :src="require('../../public/img/Logos shayofae 512x512.png')"
                  contain
                  aspect-ratio="1"
                  width="300"
                  height="240"
                  position="center"
                  class="hidden-md-and-down"
                />
              </a>
              <v-img
                :src="requireImg()"
                contain
                aspect-ratio="1"
                width="500"
                height="280"
                position="top"
                class="hidden-sm-and-down"
              />

              <!-- <v-img :src="requireImg()" contain aspect-ratio="1" position="top" class="hidden-md-and-up" /> -->

              <v-layout
                style="margin-top: 0em;vertical-align: top; max-width: 300px; height: 80px;"
                class="hidden-sm-and-down"
              >
                <div>
                  <a
                    target="_blank"
                    :href="urlFacebook()"
                    class="fb-xfbml-parse-ignore"
                    style="margin-top: 1em;margin-left: 1em;vertical-align: top;"
                  >
                    <img
                      src="../../public/img/facebook.png"
                      alt="Facebook"
                      style="width: auto; height: auto;max-width: 50px;max-height: 50px;vertical-align: top; horizontal-align: left;"
                    />
                  </a>
                  <a
                    :href="urlLinkedin()"
                    style="margin-top: 1em;margin-left: 1em;vertical-align: top;"
                    target="_blank"
                  >
                    <img
                      src="../../public/img/linkedin.png"
                      alt="LinkedIn"
                      style="width: auto; height: auto;max-width: 50px;max-height: 50px; horizontal-align: left;"
                    />
                  </a>
                  <a
                    :href="urlTwitter()"
                    style="margin-top: 1em;margin-left: 1em;vertical-align: top;"
                    target="_blank"
                  >
                    <img
                      src="../../public/img/twitter.png"
                      alt="Twitter"
                      style="width: auto; height: auto;max-width: 50px;max-height: 50px; horizontal-align: left;"
                    />
                  </a>
                  <a
                    :href="urlMail()"
                    style="margin-top: 1em;margin-left: 1em;vertical-align: top;"
                  >
                    <img
                      src="../../public/img/email.png"
                      alt="Email"
                      style="width: auto; height: auto;max-width: 50px;max-height: 50px; horizontal-align: left;"
                    />
                  </a>
                </div>
              </v-layout>
            </v-layout>
          </v-container>
        </v-avatar>

        <v-flex
          md5
          style="max-width:300em; text-align: center;font-style: oblique;color:DarkGreen;"
          class="centerer hidden-sm-and-down"
        >
          <div>
            <h1 class="display-4 font-weight-bold mb-3">
              {{ $t('home.TITLE') }}
            </h1>

            <h1 class="display-2 mb-1">{{ $t('home.SUBTITLE') }}</h1>
          </div>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    requireImg() {
      const lang = navigator.language.slice(0, 2)
      const img = require('../../public/img/gif/' +
        lang +
        '_Beta Digitis - Gif.gif')
      if (img) return img
      else return require('../../public/img/gif/en_Beta Digitis - Gif.gif')
    },
    requireImgUrl() {
      return 'http://www.shayofae.com' + this.requireImg()
    },
    urlFacebook() {
      return (
        'https://www.facebook.com/sharer/sharer.php?u=' +
        this.requireImgUrl() +
        '&src=sdkpreparse'
      )
    },
    urlLinkedin() {
      return (
        'http://www.linkedin.com/shareArticle?mini=true&url=' +
        this.requireImgUrl()
      )
    },
    urlTwitter() {
      return (
        'https://twitter.com/intent/tweet?url=' +
        this.requireImgUrl() +
        '&text=Share%20Your%20Farming%20Experience&hashtags=shayofae'
      )
    },
    urlMail() {
      return (
        'mailto:?Subject= Share Your Farming experience&Body=I%20saw%20this%20and%20thought%20of%20you!%20 %20' +
        this.requireImgUrl()
      )
      //       '+'<a href="'+this.requireImgUrl()+'">Shayofae</a>'
    },
    urlkkbb() {
      //      return this.getRoute()
      if (this.getRoute() === 'kkbb') {
        return 'https://www.kisskissbankbank.com/fr/projects/shayofae-share-your-farming-experience'
      } else {
        return '/kkbb'
      }
    },
    requireImgkkbb() {
      if (this.getRoute() === 'kkbb') {
        return require('../../public/img/bandeau_kkbb3.png')
      } else {
        return require('../../public/img/bandeau_kkbb.png')
      }
    },
    getLang() {
      return navigator.language.slice(0, 2)
    },
    getRoute() {
      return this.$route.name
    },
  },
  data() {
    return {
      width: window.innerWidth,
      icons: ['fab fa-facebook', 'fab fa-twitter', 'fab fa-linkedin'],
      links: [
        {
          link:
            'https://www.facebook.com/sharer/sharer.php?u=' +
            this.requireImg() +
            '&amp;src=sdkpreparse',
          img: require('../../public/img/facebook-logo.png'),
        },
        {
          link: 'https://www.linkedin.com/company/28131871',
          img: require('../../public/img/logo-LinkedIn.png'),
        },
        {
          link: 'https://twitter.com/shayofae',
          img: require('../../public/img/logo-twitter.png'),
        },
      ],
    }
  },
}
</script>

<style>
.headerMobile {
  padding-top: 20rem;
  width: 100%;
}
.bandeauKkbb {
  position: absolute;
  width: 400px;
  right: 140px;
  top: 250px;
}
.bandeauKkbbMobile {
  position: relative;
  width: 400px;
  right: 0px;
  top: 100px;
}
.centerer {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
}

h1 {
  padding-top: 1em;
}

.homeImg {
  background-image: url('../../public/img/Bandeau2.png');
  -webkit-background-size: cover;
  /* pour anciens Chrome et Safari */
  background-size: cover;
  padding-top: 3em;
}
</style>
